import { Component, OnInit } from '@angular/core';
import { CurrencyPair } from '@approot/models';
import { ConfigService } from '@approot/services';
import { clone } from '@approot/utilities';
import { DisplayDefinitionsService } from '../display-definitions.service';

@Component({
  selector: 'app-currency-pairs',
  templateUrl: './currency-pairs.component.html',
  styleUrls: ['./currency-pairs.component.scss']
})
export class CurrencyPairsComponent implements OnInit {
  public currencyPairs: CurrencyPair[];

  constructor(
    private svc: DisplayDefinitionsService,
    private configService: ConfigService
  ) {}

  public ngOnInit() {
    this.configService.getUserSettings().subscribe(settings => {
      this.currencyPairs = clone(settings.currencyPairs).sort((a, b) =>
        a.currencyPair.localeCompare(b.currencyPair)
      );
      this.currencyPairs.forEach(cp => {
        if (cp.lastSpotDeltaQuotedTenor === 'none') {
          cp.lastSpotDeltaQuotedTenor = 'Forward';
        } else {
          cp.lastSpotDeltaQuotedTenor = 'Spot < ' + cp.lastSpotDeltaQuotedTenor;
        }
      });
    });
  }

  public get modalOpen(): boolean {
    return this.svc.showCurrencyPairs;
  }

  public modalChanged(event: boolean) {
    this.svc.showCurrencyPairs = event;
  }
}
